

import { EnumDescription } from "../decorator/enum-description.decorator";

export class EnumSistemas {
  @EnumDescription("Portal")
  static portal = 0;

  @EnumDescription("Bardo")
  static bardo = 1;

  @EnumDescription("Integrador")
  static integrator = 2;

  // Adicionar uma propriedade auxiliar para registrar descrições
  static _descriptions: Record<string, string>;
}
